
import { Component, Vue } from 'vue-property-decorator'
import LineChart from '@/components/dashboard/charts/LineChart.vue'
import RadarChart from '@/components/dashboard/charts/RadarChart.vue'
import dashboardModule from '@/store/dashboard'
import { DealType, DealTypeText } from '@/utils/enums'
import { getKeyByValue } from '@/utils/utility-manager'

@Component({
  name: 'Dashboard',
  components: { LineChart, RadarChart }
})
class Dashboard extends Vue {
  private loading = true
  private activeUserDays = 30

  private get interestChartData() {
    return {
      labels: this.statistics.interests.map(
        (el: any) => `${el.name} (${this.getCategorieText(el.type)})`
      ),
      datasets: [
        {
          label: 'Interest',
          backgroundColor: 'rgba(255,0,0,0.5)',
          data: this.statistics.interests.map((el: any) => el.sum)
        }
      ]
    }
  }

  private get chartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scale: {
        ticks: {
          suggestedMin: 0
        }
      }
    }
  }

  private get statistics(): any {
    return dashboardModule.statistics
  }

  private get usersTotal(): number {
    const totalUser = this.statistics.users.find(
      (el: any) => el.name === 'user'
    )
    return totalUser ? totalUser.sum : 0
  }

  private get activeUsers(): number {
    return this.statistics.activeUsers[this.activeUserDays]
  }

  private get dealsActive(): number {
    const activeDeals = this.statistics.deals.find(
      (el: any) => el.name === 'active'
    )
    return activeDeals ? activeDeals.sum : 0
  }

  private get companiesTotal(): number {
    return this.statistics.companies.total
  }

  private async created(): Promise<void> {
    await dashboardModule.fetchStatistics()
    this.loading = false
  }

  private getCategorieText(value: string): string {
    return DealTypeText[getKeyByValue(DealType, value)]
  }
}

export default Dashboard
